/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Rooster_Uitleg_TijdenInputs */

const nl_planning_rooster_uitleg_tijden = /** @type {(inputs: Planning_Rooster_Uitleg_TijdenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De tijden links gelden voor die dag.`)
};

/**

* @param {Planning_Rooster_Uitleg_TijdenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_uitleg_tijden = /** @type {((inputs?: Planning_Rooster_Uitleg_TijdenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Uitleg_TijdenInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_uitleg_tijden(inputs)
});
export { planning_rooster_uitleg_tijden as "planning.rooster.uitleg_tijden" }